<template>
	<div>
		<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
			@selection-change="handleSelectionChange" size="mini">
			<el-table-column type="selection" width="55" v-if="multSelect">
			</el-table-column>
			<el-table-column type="index" width="60" label="序号">
				<template slot-scope="scope">
					<span>{{scope.$index+1+(page.pageIndex-1)*page.pageSize}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			<el-table-column prop="exam_score" label="总分" width="60"></el-table-column>
			<el-table-column prop="gender" label="性别" width="60">
				<template slot-scope="scope">
			
					<span v-if="scope.row.gender==1">男</span>
					<span v-if="scope.row.gender==2">女</span>
			
					<span v-if="scope.row.gender==0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="graduate_sch_city" label="地区" width="150">
				<template slot-scope="scope">
							
					{{getCity(scope.row.graduate_sch_city)}}
				</template>
			</el-table-column>
			<el-table-column prop="major_name" label="专业" min-width="140"></el-table-column>
			<el-table-column prop="phone" label="联系方式"  min-width="120"></el-table-column>
			<el-table-column prop="phone" label="体检状态"  width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.pjson" style="color: green;">已体检</span>
					
					<span v-else style="color: orangered;">未体检</span>
				
				</template>
				
			</el-table-column>
			<el-table-column prop="username" label="体检人" width="100">
				<template slot-scope="scope">
					<span v-for="(sp,i) in scope.row.splogs" :key="i" v-if="sp.stu_status==0.5">{{ sp.username }}</span>
				
				</template>

			</el-table-column>
			<el-table-column prop="cdate" label="体检时间" width="150">
				<template slot-scope="scope">
					<span v-for="(sp,i) in scope.row.splogs" :key="i" v-if="sp.stu_status==0.5">{{ sp.udate }}</span>
				</template>
			</el-table-column>

			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==1" style="color: green;">已审核</span>
					<span v-if="scope.row.status==2"  style="color: blue;">已缴费</span>
					<span v-if="scope.row.status==3"  style="color: deepskyblue;">已录取</span>
					<span v-if="scope.row.status==4"  style="color: #096DD9;">已分班</span>
					<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
					<span v-if="scope.row.status==-2" style="color: orangered;">已退档</span>
					<span v-if="scope.row.status==0||scope.row.status==0.5"  style="color: gray;">未审核</span>
				</template>
			</el-table-column>

			
			

			<el-table-column fixed="right" label="操作" width="100" >
				<template slot-scope="scope">
					<el-button v-if="scope.row.status==1"  @click="handleModify(scope.row)"  type="text" size="small">收费</el-button>
					<el-button v-if="scope.row.status>=1"  @click="showPrintDialog(scope.row)"  type="text" size="small">缴费单</el-button>
					<el-button v-if="scope.row.status>1"  @click="handleModify(scope.row)"  type="text" size="small">查看</el-button>
				 
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>

		<FeeLQprint v-if="showPrint" :stuid="stuid"></FeeLQprint>
		

    </div>
</template>
<script>
import FeeLQprint from "../../njcj/com/PrintFee.vue"
    export default {
		name: 'Table',
		components:{
			FeeLQprint
		},
		name: 'Table',
		data() {
			return {
				stuid:0,
				showPrint:false,
                showBM:false,
				stuid:0
            }
		},
		props: {
			page: {
				type: Object,
			},
			tableData: {
				type: Array,
				default: []
			},
			from: {
				type: String,
				default: ''
			},
			multSelect: {
				type: Boolean,
				default: true
			},
            pmid: {
                type: Number,
                default: 1
            }

        },
		methods: {
			handleModify(row) {
				this.$emit('handleModify', row)
			},
			handleDel(row) {
				this.$emit('handleDel', row)
			},
			handleSelectionChange(val) {
				this.$emit('handleSelectionChange', val)
			},
			handlePageChange(e) {
				this.$emit('handlePageChange', e)
			},
			handleSizeChange(e) {
				this.$emit('handleSizeChange', e)
			},
			showPrintDialog(e){
				this.stuid = e.id
				this.showPrint = true
			},
			closePrint(){
				this.showPrint = false
			},
            //BM
            showBMDialog(e){
                this.stuid = e.id
                this.showBM = true
            },
            closeBM(){
                this.showBM = false
            },
		}
	}
</script>
